import { h } from 'preact';
import * as BaseComp from 'components/bolt/socials/socials.js';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import { findInVNode } from 'utils/vnode';
import socialS from 'components/bolt/socials/socials.sss';
import headerS from 'components/bolt/header/headerExpanded.sss';

import Shop from 'components/bolt/icons/shop';



export default class Socials extends BaseComp.default {
	getIcon(id, data) {
		const props = this.props;
		const attr = { class: props.iconStyle || socialS.icon };
		if (id === 'shop') return <Shop {...attr} />; // No shop link for Kazoo Films
		return super.getIcon(id, data);
	}
	render(props) {
		const store = Store.get();
		const {
			showtimesOverlay,
			homeEntOverlay,
			pressKitOverlay,
		} = props.headerData || {};

		const base = super.render(props);

		const container = findInVNode(base, `.${headerS.container}`);
		if (container) {
			container.attributes.class = joinClasses(
				container.attributes.class, 
				(showtimesOverlay || store.widgetFullyExpanded) && headerS.showtimes,
				homeEntOverlay && headerS.homeEnt,
				pressKitOverlay && headerS.pressKit
			);
		}
		return base;
	}
}